export enum AuthFailureEvent {
  Unauthorized = 401,     // 401 - Unauthorized. Session expired or invalid.
  AccessBlockedByIP = 421,  // 421 - IP Whitelist. Access blocked because of IP.
  SessionExpiredByPolicy = 425    // 425 - Company security policy. Session expired either because of idle timeout, absolute timeout or daily logout time.
}
